export class Register extends HTMLElement {
    constructor() {
        super();

        this._selectors = {
            submitButton: "[js-create-account]",
            termsCheckbox: "[js-terms]",
        };
    }

    connectedCallback() {
        this.submitButton = this.querySelector(this._selectors.submitButton);
        this.checkbox = this.querySelector(this._selectors.termsCheckbox);
        this.submitButton.addEventListener("click", this._validateForm);
    }

    _validateForm = (e) => {
        if (!this.checkbox.checked) {
            e.preventDefault();
            alert("Please agree to the terms and privacy policy");
        }
    };
}
